var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", { staticClass: "light" }, [
        _vm._v("Expired/Inactive Users Export")
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form-inline",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.download.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { attrs: { for: "user_type" } },
              [
                _vm._v("\n        User Type "),
                _c("i", {
                  staticClass: "fa fa-info-circle",
                  attrs: { id: "user_type_tooltip" }
                }),
                _vm._v(" "),
                _c("tooltip", {
                  attrs: {
                    text:
                      "Enterprise means they're in a domain/part of a district customer. Consumer means they're individual sign ups.",
                    target: "#user_type_tooltip"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reportParams.user_type,
                    expression: "reportParams.user_type"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "user_type", disabled: _vm.loading },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.reportParams,
                      "user_type",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("Enterprise and Consumers")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "enterprise" } }, [
                  _vm._v("Enterprise")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "consumer" } }, [
                  _vm._v("Consumer")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "expired_before_date" } }, [
              _vm._v(" Expired Before ")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.reportParams.expired_before,
                  expression: "reportParams.expired_before"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "date",
                id: "expired_before_date",
                disabled: _vm.loading
              },
              domProps: { value: _vm.reportParams.expired_before },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.reportParams,
                    "expired_before",
                    $event.target.value
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "last_active_before_date" } }, [
              _vm._v(" Last Active Before ")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.reportParams.last_active_before,
                  expression: "reportParams.last_active_before"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "date",
                id: "last_active_before_date",
                disabled: _vm.loading
              },
              domProps: { value: _vm.reportParams.last_active_before },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.reportParams,
                    "last_active_before",
                    $event.target.value
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkbox" }, [
            _c("label", { attrs: { for: "apply_retention_policy" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reportParams.apply_retention_policy,
                    expression: "reportParams.apply_retention_policy"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  id: "apply_retention_policy",
                  disabled: _vm.loading
                },
                domProps: {
                  checked: Array.isArray(
                    _vm.reportParams.apply_retention_policy
                  )
                    ? _vm._i(_vm.reportParams.apply_retention_policy, null) > -1
                    : _vm.reportParams.apply_retention_policy
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.reportParams.apply_retention_policy,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.reportParams,
                            "apply_retention_policy",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.reportParams,
                            "apply_retention_policy",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.reportParams, "apply_retention_policy", $$c)
                    }
                  }
                }
              }),
              _vm._v("\n        Apply Retention Policy?\n      ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("File Format")]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fileType,
                    expression: "fileType"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: "file-format",
                  id: "file-format-csv",
                  value: "csv",
                  disabled: _vm.loading
                },
                domProps: { checked: _vm._q(_vm.fileType, "csv") },
                on: {
                  change: function($event) {
                    _vm.fileType = "csv"
                  }
                }
              }),
              _vm._v("\n        CSV\n      ")
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "radio-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fileType,
                    expression: "fileType"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: "file-format",
                  id: "file-format-xlsx",
                  value: "xlsx",
                  disabled: _vm.loading
                },
                domProps: { checked: _vm._q(_vm.fileType, "xlsx") },
                on: {
                  change: function($event) {
                    _vm.fileType = "xlsx"
                  }
                }
              }),
              _vm._v("\n        XLSX\n      ")
            ])
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: !_vm.enableDownload || _vm.loading }
            },
            [
              _vm.loading
                ? [
                    _c("i", { staticClass: "fa fa-circle-o-notch fa-spin" }),
                    _vm._v(" Downloading...")
                  ]
                : [_vm._v("Download")]
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm.error
        ? _c("alert", { attrs: { type: "danger", dismissible: "" } }, [
            _vm._v(_vm._s(_vm.error))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }